// removed by extract-text-webpack-plugin
module.exports = {"link":"EditTemplate__link___3yWM6","container":"EditTemplate__container___3fD7w","legend":"EditTemplate__legend___1RfTP","content":"EditTemplate__content___GS7Cj"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/EditTemplate.less
 ** module id = 762
 ** module chunks = 0
 **/